import { SELECT_STUDENT  } from "../constants/ActionTypes";

const initialState =
{
    activeStudent:
    {
        kerbId: "",
        name: ""
    }
};

export default function student(state = initialState, action: any) 
{
    switch (action.type) 
{
        case SELECT_STUDENT:
            {
                return { ...state, activeStudent: action.payload.response };
            }

        default:
            return state;
    }
}